import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast, Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import { errMsg } from "@/lib/errors";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    if (!token) return toast.error("Missing reset token — open the link from your email again");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Password updated — you can log in with your new password");
      setTimeout(() => nav("/login", { replace: true }), 1200);
    } catch (err) {
      toast.error(errMsg(err, "Could not reset password"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Toaster position="top-center" />
      <div className="max-w-md mx-auto px-4 py-14">
        <h1 className="font-display text-3xl font-bold text-slate-900">Choose a new password</h1>
        <p className="text-slate-600 mt-2">
          Use at least 8 characters. Your account stays exactly the same — only the password changes.
        </p>

        {!token && (
          <div className="mt-6 card border-amber-200 bg-amber-50 text-amber-900 text-sm">
            This link is missing its reset token. Please open the reset link from the email again, or{" "}
            <Link to="/forgot-password" className="font-semibold underline">request a new one</Link>.
          </div>
        )}

        <form onSubmit={submit} className="mt-6 card space-y-4">
          <div>
            <label className="label">New password</label>
            <input
              data-testid="reset-new-password"
              type="password"
              required
              minLength={8}
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="field"
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className="label">Confirm new password</label>
            <input
              data-testid="reset-confirm-password"
              type="password"
              required
              minLength={8}
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="field"
              autoComplete="new-password"
            />
          </div>
          <button
            data-testid="reset-submit-btn"
            disabled={busy || done || !token}
            className="btn-accent w-full"
          >
            {done ? "Password updated ✓" : busy ? "Saving…" : "Set new password"}
          </button>
          <div className="text-sm text-slate-600 text-center">
            <Link to="/login" className="text-emerald-600 font-semibold">Back to login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
